import Inc from "@/modules/inc/service/Inc.js";
import Core from "@/modules/core/service/Core";

export const actions = {
    getIncidentById ( { commit }, id) {
        return Core.method.get(Inc.url.incidentId, id).then((incident) => {
            commit ('updateIncident', incident);
        });
    },

    updateIncident ( { commit }, incident, documents ) {
        commit ('updateIncident', incident, documents);
    },

    updateDocuments ( { commit }, documents ) {
        commit ('updateDocuments', documents);
    },

    initIncidentEnums ( { commit }) {
        return Core.method.get(Inc.url.enums).then(data => {
            commit ('updateIncidentEnums', data);
        })
    },

    findHistoryByIncident ( { commit }, incidentId) {
        return Core.method.get(Inc.url.history, incidentId).then(data => {
            commit ('updateStepdatahistory', data);
        })
    },

    refreshClipboard ( { commit }, customerId) {
        if (!customerId) {
            commit ('updateClipboard', []);
            return;
        }

        Inc.clipboard.list(customerId).then ((data) => {
            commit ('updateClipboard', data);
        });
    },

    addManufacturer ( { commit }, manufacturer) {
        commit ('updateManufacturerList', manufacturer);
    },

    storeTodo ( { commit }, todo) {
        commit ('updateTodo', todo);
    },
}
